import React, { useCallback, useEffect } from 'react';
import PausePresentationIcon from '@material-ui/icons/PausePresentation';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import BroadcasterStore from 'stores/BroadcasterStore';
import FirebaseStore from 'stores/FirebaseStore';
import UserStore from 'stores/UserStore';
import LoadingButton from 'components/LoadingButton/LoadingButton';
import APIStates from 'enum/APIStates';

import styles from './BroadcasterPauseState.css';


const MILISECONDS_INTERVAL = 1000;

function BroadcasterPauseState() {
  const {
    resumeBroadcast,
    uiVariables: { autoPauseDurationMillis },
    isStreamResuming,
    formatedPausedTimer,
    updatePausedRemainingTimer,
    getPausedRemainingTime,
    pausedRemainingTimer,
    webserverTimeStatus,
  } = BroadcasterStore;
  const { user: { username, accessHash } } = UserStore;
  const { pauseTimestamp } = FirebaseStore;

  useEffect(() => {
    getPausedRemainingTime(pauseTimestamp + autoPauseDurationMillis);
  }, [autoPauseDurationMillis, pauseTimestamp, getPausedRemainingTime]);

  useEffect(() => {
    let countdown = null;
    if (webserverTimeStatus === APIStates.LOADED) {
      countdown = setTimeout(() => {
        if (pausedRemainingTimer <= 0) {
          updatePausedRemainingTimer(0);
          clearTimeout(countdown);
        } else {
          updatePausedRemainingTimer(pausedRemainingTimer - MILISECONDS_INTERVAL);
        }
      }, MILISECONDS_INTERVAL);
    }

    return () => {
      clearTimeout(countdown);
    };
  }, [webserverTimeStatus, pausedRemainingTimer, updatePausedRemainingTimer]);

  const handleResume = useCallback(() => {
    resumeBroadcast(username, accessHash);
  }, [username, accessHash, resumeBroadcast]);

  return (
    <div className={styles.wrapper}>
      <PausePresentationIcon />
      <div className={styles.title}>
        {translate('v2broadcast.stream.paused')}
      </div>
      <p className={styles.text}>
        {translate('v2broadcast.broadcast.will.end')}
        {' '}
        {formatedPausedTimer}
      </p>
      <LoadingButton
        colorVariant="white"
        isLoading={isStreamResuming}
        onClick={handleResume}
      >
        {translate('v2broadcast.resume.stream')}
      </LoadingButton>
    </div>
  );
}

export default observer(BroadcasterPauseState);
